import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Small sparkle badge rendered inline beside a premium member's name.
 * Hidden completely when `show` is false, so it's safe to render unconditionally.
 * Uses forwardRef so parent components (Tooltips, Popovers) can attach refs.
 */
const PremiumBadge = React.forwardRef(({ show, size = 14, className = '', ...rest }, ref) => {
  if (!show) return null;
  return (
    <span
      ref={ref}
      role="img"
      aria-label="Sirati+ member"
      className={`inline-flex items-center justify-center text-primary ${className}`}
      data-testid="premium-badge"
      {...rest}
    >
      <Sparkles aria-hidden="true" style={{ width: size, height: size }} className="fill-primary/20" />
    </span>
  );
});

PremiumBadge.displayName = 'PremiumBadge';

export default PremiumBadge;
